import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { hideModal } from 'actions/internal';

class AsqSurveyEmailSendoutConfirmationModal extends React.Component {
  handleCancelClick = () => {
    this.props.hideModal();
  }

  handleConfirmClick = () => {
    this.props.onConfirm();
    this.props.hideModal();
  }

  render() {
    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>{this.props.t('player.confirmAsqEmailTitle')}</b></h2>
        <hr className='u-margin-top--zero'/>

        <p>{this.props.t('player.confirmAsqEmailBody')}</p>
        <p>{this.props.t('player.confirmAsqEmailPdfNote')}</p>

        <div className="row">
          <div className='column grow'>
            <a className='o-sp-button o-sp-button--note cs-txt-link--sp-blue' onClick={this.handleCancelClick}>{this.props.t('actions.cancel')}</a>
          </div>
          <div className='column shrink'>
            <a className='o-sp-button o-sp-button--note o-sp-button--primary' onClick={this.handleConfirmClick}>{this.props.t('player.sendResultsEmail')}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  hideModal,
})(withTranslation()(AsqSurveyEmailSendoutConfirmationModal));
